/**
 * Archive modal — a consistently-wide modal (reuses the .add-release-modal / .arm-* frame) showing a
 * standard multi-select GRID of ARCHIVED (soft-deleted) items, with RESTORE and DELETE PERMANENTLY
 * actions once along the bottom (mirrors the import-release modal). Select items → act on them.
 *
 * Global + page-agnostic: opens OVER whatever page you're on; never navigates. Data:
 * GET /catalog/archived/data. Actions: POST /loudlinks/:id/restore, POST /loudlinks/:id/delete.
 */
(function () {
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function selArtist() {
    try { return (window.ArtistSwitcher && ArtistSwitcher.getSelectedArtistId && ArtistSwitcher.getSelectedArtistId()) || ''; }
    catch (_) { return ''; }
  }
  function ok(r) { if (!r.ok) throw new Error('http ' + r.status); return r.json().catch(function () { return {}; }); }
  function toast(m) { if (window.showToast) window.showToast(m); }
  function changed() { try { window.dispatchEvent(new CustomEvent('llink:archive-changed')); } catch (_) {} }

  // ── Restore with a slug conflict ─────────────────────────────────────────────────────────────────
  // Archiving frees a page's slug. If a live page has taken it since, restoring can't reuse it: the
  // server answers 409 { conflict, slug, suggested, taken_by, artist_id, title } and the user picks a new
  // address here (same styled dialog family as the archive confirms), checked live as they type.
  function slugify(v) { return String(v || '').toLowerCase().trim().replace(/[^a-z0-9-]+/g, '-').replace(/-{2,}/g, '-').replace(/^-|-$/g, ''); }
  function promptRestoreSlug(c) {
    return new Promise(function (resolve) {
      var o = document.createElement('div');
      o.className = 'delete-modal-overlay is-visible';
      o.style.zIndex = '100003';
      o.innerHTML =
        '<div class="delete-modal restore-slug-modal">' +
          '<div class="delete-modal-icon restore-slug-icon"><i class="bi bi-arrow-counterclockwise"></i></div>' +
          '<p class="delete-modal-title">Choose a new address</p>' +
          '<p class="delete-modal-text"><span class="delete-modal-name">/' + esc(c.slug) + '</span> is now used by ' +
            (c.taken_by ? '<span class="delete-modal-name">' + esc(c.taken_by) + '</span>' : 'another page') +
            '. Pick a new address to restore <span class="delete-modal-name">' + esc(c.title || 'this page') + '</span>.</p>' +
          '<label class="restore-slug-field"><span class="restore-slug-prefix">/</span>' +
            '<input type="text" class="restore-slug-input" spellcheck="false" autocomplete="off" maxlength="120" /></label>' +
          '<p class="restore-slug-status" aria-live="polite"></p>' +
          '<div class="delete-modal-buttons">' +
            '<button type="button" class="delete-modal-btn delete-modal-btn-primary" data-confirm>Restore</button>' +
            '<button type="button" class="delete-modal-btn delete-modal-btn-cancel" data-cancel>Cancel</button>' +
          '</div>' +
        '</div>';
      document.body.appendChild(o);
      var input = o.querySelector('.restore-slug-input'), status = o.querySelector('.restore-slug-status');
      var btn = o.querySelector('[data-confirm]'), seq = 0, timer = null, busy = false, done = false;
      input.value = c.suggested || '';
      function finish(v) { if (done) return; done = true; try { o.remove(); } catch (_) {} resolve(v); }
      function setStatus(msg, bad) { status.textContent = msg || ''; status.classList.toggle('is-bad', !!bad); }
      function check() {
        var v = slugify(input.value), my = ++seq;
        if (!v) { btn.disabled = true; setStatus('Enter an address', true); return; }
        if (v === c.slug) { btn.disabled = true; setStatus('That address is taken', true); return; }
        btn.disabled = true; setStatus('Checking…');
        fetch('/loudlinks/check-slug?slug=' + encodeURIComponent(v) + '&artist_id=' + encodeURIComponent(c.artist_id) + '&exclude_id=' + encodeURIComponent(c.id))
          .then(ok).then(function (d) {
            if (my !== seq) return;
            if (d && d.available) { btn.disabled = false; setStatus(''); } else { setStatus('That address is taken', true); }
          }).catch(function () { if (my === seq) { btn.disabled = false; setStatus(''); } });   // can't check → let the server decide
      }
      input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(check, 220); });
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter' && !btn.disabled) submit(); if (e.key === 'Escape') finish(null); });
      o.addEventListener('click', function (e) { if (window.overlayDismissClick ? window.overlayDismissClick(e, o) : e.target === o) finish(null); });
      o.querySelector('[data-cancel]').addEventListener('click', function () { finish(null); });
      function submit() {
        if (busy) return;
        var v = slugify(input.value);
        if (!v) return;
        busy = true; btn.disabled = true; btn.textContent = 'Restoring…';
        fetch('/loudlinks/' + c.id + '/restore', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ slug: v }) })
          .then(function (r) { return r.json().then(function (d) { return { status: r.status, d: d }; }); })
          .then(function (x) {
            busy = false; btn.textContent = 'Restore';
            if (x.d && x.d.success) return finish({ ok: true, slug: x.d.slug });
            if (x.status === 409 && x.d && x.d.conflict) { input.value = x.d.suggested || ''; setStatus('That address was just taken — try this one', true); btn.disabled = !input.value; return; }
            setStatus((x.d && x.d.error) || 'Couldn’t restore — try again', true); btn.disabled = false;
          }).catch(function () { busy = false; btn.textContent = 'Restore'; btn.disabled = false; setStatus('Couldn’t restore — try again', true); });
      }
      btn.addEventListener('click', submit);
      setTimeout(function () { input.focus(); input.select(); }, 40);
      check();
    });
  }
  // Restore one page; on a slug conflict, prompt for a new address. → 'restored' | 'cancelled' | 'failed'.
  function restoreOne(id) {
    return fetch('/loudlinks/' + id + '/restore', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { return { status: r.status, d: d }; }); })
      .then(function (x) {
        if (x.d && x.d.success) return 'restored';
        if (x.status === 409 && x.d && x.d.conflict) return promptRestoreSlug(x.d).then(function (v) { return v ? 'restored' : 'cancelled'; });
        return 'failed';
      }).catch(function () { return 'failed'; });
  }
  // Prompt through a list of conflicts (from restore-all), one at a time. → number restored.
  function resolveConflicts(list) {
    var n = 0;
    return (list || []).reduce(function (p, c) {
      return p.then(function () { return promptRestoreSlug(c).then(function (v) { if (v) n++; }); });
    }, Promise.resolve()).then(function () { return n; });
  }
  window.LoudRestore = { restoreOne: restoreOne, resolveConflicts: resolveConflicts, prompt: promptRestoreSlug };

  // Styled confirm for the (irreversible) permanent delete of N items.
  function confirmBulkDelete(n, onYes) {
    var o = document.createElement('div');
    o.className = 'delete-modal-overlay is-visible';
    o.style.zIndex = '100002';
    o.innerHTML =
      '<div class="delete-modal">' +
        '<div class="delete-modal-icon"><i class="bi bi-trash3"></i></div>' +
        '<p class="delete-modal-title">Delete permanently</p>' +
        '<p class="delete-modal-text">Permanently delete ' + n + ' item' + (n === 1 ? '' : 's') + '? This cannot be undone.</p>' +
        '<div class="delete-modal-buttons">' +
          '<button type="button" class="delete-modal-btn delete-modal-btn-delete" data-confirm style="width:100%;">Delete permanently</button>' +
          '<button type="button" class="delete-modal-btn delete-modal-btn-cancel" data-cancel>Cancel</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(o);
    function close() { try { o.remove(); } catch (_) {} }
    o.addEventListener('click', function (e) { if (window.overlayDismissClick ? window.overlayDismissClick(e, o) : e.target === o) close(); });
    o.querySelector('[data-cancel]').addEventListener('click', close);
    o.querySelector('[data-confirm]').addEventListener('click', function () { close(); onYes(); });
  }

  // Shared with the phone sheet (main.ejs, James 2026-11-01), which does the same as this modal's two buttons.
  // Restore one at a time (a page whose address is now taken asks for a new one); resolves the ids restored.
  function restoreMany(ids) {
    var restored = [];
    return ids.reduce(function (p, id) {
      return p.then(function () { return restoreOne(id).then(function (r) { if (r === 'restored') restored.push(id); }); });
    }, Promise.resolve()).then(function () {
      if (restored.length) { toast('Restored ' + restored.length + ' item' + (restored.length === 1 ? '' : 's')); changed(); }
      return restored;
    });
  }
  // Delete for good, after the same confirm; onDone once they're gone.
  function deleteMany(ids, onDone) {
    confirmBulkDelete(ids.length, function () {
      Promise.all(ids.map(function (id) { return fetch('/loudlinks/' + id + '/delete', { method: 'POST', headers: { 'Accept': 'application/json' } }).then(ok).catch(function () { return null; }); }))
        .then(function () { toast('Deleted ' + ids.length + ' item' + (ids.length === 1 ? '' : 's')); changed(); if (onDone) onDone(); });
    });
  }

  function open() {
    // PHONES: the Archive is a view of the grid (releases-page.js, Restore / Delete bar); away from the grid, the sheet.
    if (window.matchMedia && window.matchMedia('(max-width: 767.98px)').matches) {
      if (window.RelGrid && window.RelGrid.openArchive && document.getElementById('relGrid')) { window.RelGrid.openArchive(); return; }
      if (window.LLArchiveSheet) { window.LLArchiveSheet(); return; }
    }
    var existing = document.querySelector('.archive-modal-overlay');
    if (existing) existing.remove();

    var overlay = document.createElement('div');
    overlay.className = 'add-release-modal-overlay archive-modal-overlay';
    overlay.innerHTML =
      '<div class="add-release-modal">' +
        '<div class="arm-header">' +
          '<h2 class="arm-title">Archived</h2>' +
          '<div class="arm-header-actions">' +
            '<button class="arm-selectall" id="archSelectAll" style="display:none;">Select all</button>' +
            '<button class="arm-close" aria-label="Close"><i class="bi bi-x-lg"></i></button>' +
          '</div>' +
        '</div>' +
        '<div class="arm-body"><div class="arm-grid" id="archGrid"><div class="arm-loading">Loading archived…</div></div></div>' +
        '<div class="arm-footer" id="archFooter" style="display:none;">' +
          '<span class="arm-footer-hint" id="archHint">Select items to restore or delete</span>' +
          '<div class="arch-footer-btns">' +
            '<button type="button" class="arm-selectall" id="archRestore" disabled>Restore</button>' +
            '<button type="button" class="arm-import-btn arch-delete-btn" id="archDelete" disabled>Delete permanently</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(overlay);
    requestAnimationFrame(function () { overlay.classList.add('is-visible'); });

    function close() { overlay.classList.remove('is-visible'); setTimeout(function () { try { overlay.remove(); } catch (_) {} }, 180); }
    overlay.addEventListener('click', function (e) { if (window.overlayDismissClick ? window.overlayDismissClick(e, overlay) : e.target === overlay) close(); });
    overlay.querySelector('.arm-close').addEventListener('click', close);
    document.addEventListener('keydown', function esckey(e) { if (e.key === 'Escape') { close(); document.removeEventListener('keydown', esckey); } });

    var grid = overlay.querySelector('#archGrid');
    var footer = overlay.querySelector('#archFooter');
    var hint = overlay.querySelector('#archHint');
    var restoreBtn = overlay.querySelector('#archRestore');
    var deleteBtn = overlay.querySelector('#archDelete');
    var selectAllBtn = overlay.querySelector('#archSelectAll');
    var sel = selArtist();
    var selected = {};
    var total = 0;

    function tileHtml(it) {
      // No artwork: the same placeholder gradient it had in the grid (James 2026-10-31), not a file icon.
      var img = it.primary_artwork_url
        ? '<img src="' + esc(it.primary_artwork_url) + '" alt="">'
        : '<div class="arch-card-noimg" style="background:' + archGradientFor(it.id) + '"></div>';
      return '<button type="button" class="arm-tile arm-tile-release" data-id="' + it.id + '" data-name="' + esc(it.title) + '">' +
        '<div class="arm-tile-art">' + img + '<div class="arm-tile-check"><i class="bi bi-check-lg"></i></div></div>' +
        '<div class="arm-tile-title" title="' + esc(it.title) + '">' + esc(it.title) + '</div>' +
        '<div class="arm-tile-meta">' + (esc(it.artist) || '&nbsp;') + '</div>' +
      '</button>';
    }
    function updateFooter() {
      var n = Object.keys(selected).length;
      restoreBtn.disabled = deleteBtn.disabled = (n === 0);
      hint.textContent = n ? (n + ' selected') : 'Select items to restore or delete';
      selectAllBtn.textContent = (total > 0 && n === total) ? 'Deselect all' : 'Select all';
    }

    fetch('/catalog/archived/data?page=0' + (sel ? '&artist=' + encodeURIComponent(sel) : ''))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var items = (d && d.releases) || [];
        total = items.length;
        if (!items.length) { grid.innerHTML = '<div class="arm-loading">Nothing archived</div>'; return; }
        grid.innerHTML = items.map(tileHtml).join('');
        footer.style.display = '';
        selectAllBtn.style.display = '';
        updateFooter();
      })
      .catch(function () { grid.innerHTML = '<div class="arm-loading">Couldn’t load archived items</div>'; });

    grid.addEventListener('click', function (e) {
      var tile = e.target.closest('.arm-tile-release');
      if (!tile) return;
      var id = tile.dataset.id;
      if (selected[id]) { delete selected[id]; tile.classList.remove('is-selected'); }
      else { selected[id] = true; tile.classList.add('is-selected'); }
      updateFooter();
    });

    selectAllBtn.addEventListener('click', function () {
      var tiles = grid.querySelectorAll('.arm-tile-release');
      var allSel = Object.keys(selected).length === total;
      selected = {};
      tiles.forEach(function (t) {
        if (allSel) { t.classList.remove('is-selected'); }
        else { selected[t.dataset.id] = true; t.classList.add('is-selected'); }
      });
      updateFooter();
    });

    function removeTiles(ids) {
      ids.forEach(function (id) {
        var t = grid.querySelector('.arm-tile-release[data-id="' + id + '"]');
        if (t) t.remove();
        delete selected[id];
      });
      total = grid.querySelectorAll('.arm-tile-release').length;
      if (!total) { grid.innerHTML = '<div class="arm-loading">Nothing archived</div>'; footer.style.display = 'none'; selectAllBtn.style.display = 'none'; }
      updateFooter();
    }
    function removeSelectedTiles() {
      Object.keys(selected).forEach(function (id) {
        var t = grid.querySelector('.arm-tile-release[data-id="' + id + '"]');
        if (t) t.remove();
      });
      selected = {};
      total = grid.querySelectorAll('.arm-tile-release').length;
      if (!total) { grid.innerHTML = '<div class="arm-loading">Nothing archived</div>'; footer.style.display = 'none'; selectAllBtn.style.display = 'none'; }
      updateFooter();
    }

    restoreBtn.addEventListener('click', function () {
      var ids = Object.keys(selected);
      if (!ids.length) return;
      restoreBtn.disabled = deleteBtn.disabled = true;
      // One at a time: a page whose slug is now taken prompts for a new address before the next.
      var restored = [];
      ids.reduce(function (p, id) {
        return p.then(function () { return restoreOne(id).then(function (r) { if (r === 'restored') restored.push(id); }); });
      }, Promise.resolve()).then(function () {
        if (restored.length) toast('Restored ' + restored.length + ' item' + (restored.length === 1 ? '' : 's'));
        removeTiles(restored);
        restoreBtn.disabled = deleteBtn.disabled = false;
        updateFooter();
        if (restored.length) changed();
      });
    });

    deleteBtn.addEventListener('click', function () {
      var ids = Object.keys(selected);
      if (!ids.length) return;
      confirmBulkDelete(ids.length, function () {
        restoreBtn.disabled = deleteBtn.disabled = true;
        Promise.all(ids.map(function (id) { return fetch('/loudlinks/' + id + '/delete', { method: 'POST', headers: { 'Accept': 'application/json' } }).then(ok).catch(function () { return null; }); }))
          .then(function () { toast('Deleted ' + ids.length + ' item' + (ids.length === 1 ? '' : 's')); removeSelectedTiles(); });
      });
    });
  }

  // ── Sidebar trash button (above search): visible only while the archive has items. The count is
  // scoped to the selected workspace; refreshed on load, workspace switch and any archive change. The
  // releases page also pushes its own count straight in via ArchiveModal.setCount (no refetch).
  function setCount(n) {
    n = Math.max(0, n | 0);
    var wrap = document.getElementById('sidebarArchive'), btn = document.getElementById('sidebarArchiveBtn');
    if (!wrap || !btn) return;
    var label = 'Archived — ' + n + (n === 1 ? ' item' : ' items');
    btn.title = label; btn.setAttribute('aria-label', label);
    gooShow(wrap, btn, n > 0);
  }
  // Gooey show/hide (gooey-ui: springs, never tweens). Showing: the slot opens on a spring (search glides
  // down) while the button swells in with one soft overshoot. Hiding: it drains back to nothing, no
  // wobble, and the slot closes. A newer call takes over mid-flight from wherever it is.
  function gooShow(wrap, btn, show) {
    var shown = wrap.dataset.shown === '1';
    if (show === shown && !wrap._goo) return;
    wrap.dataset.shown = show ? '1' : '0';
    var reduced = false; try { reduced = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (_) {}
    if (reduced) { wrap.style.display = show ? '' : 'none'; wrap.style.height = ''; wrap.style.overflow = ''; wrap.style.marginBottom = ''; btn.style.transform = ''; return; }
    if (wrap._goo) wrap._goo.stop = true;
    wrap.style.display = '';
    wrap.style.overflow = 'visible';
    wrap.style.height = '';
    var H = wrap.offsetHeight || 40;                        // natural slot height
    var pcs = getComputedStyle(wrap.parentNode);
    var column = String(pcs.flexDirection).indexOf('column') === 0;   // desktop rail; narrow screens lay the row out horizontally
    var gap = parseFloat(pcs.rowGap) || 0;   // the column gap springs too (no jump)
    btn.style.transition = 'none';                          // per-frame spring, not the button's CSS ease
    var cur = wrap._goo ? wrap._goo.s.x : (show ? 0 : 1);   // continue from wherever a previous run left it
    var s = { x: cur, v: 0, t: show ? 1 : 0, w: show ? 15 : 18, z: show ? 0.6 : 1 };
    var run = { s: s, stop: false };
    wrap._goo = run;
    var last = 0;
    (function frame(now) {
      if (run.stop) return;
      var dt = last ? Math.min(0.05, (now - last) / 1000) : 1 / 60; last = now;
      var steps = Math.max(1, Math.ceil(dt * 240)), h = dt / steps, k = s.w * s.w, c = 2 * s.z * s.w;
      for (var i = 0; i < steps; i++) { s.v += (-k * (s.x - s.t) - c * s.v) * h; s.x += s.v * h; }
      var x = Math.max(0, s.x);
      var xm = Math.min(1, x);
      if (!column) { btn.style.transform = 'scale(' + x.toFixed(4) + ')'; }   // horizontal row: just the scale
      else {
      wrap.style.height = (H * xm).toFixed(2) + 'px';
      wrap.style.marginBottom = (-gap * (1 - xm)).toFixed(2) + 'px';
      // Scale from the button's OWN centre, pinned where it will rest: the slot's bottom sits on search
      // and grows upward, so shift the button by the not-yet-open part of the slot (+ gap) each frame.
      btn.style.transform = 'translateY(' + (H * xm - H - gap * (1 - xm)).toFixed(2) + 'px) scale(' + x.toFixed(4) + ')';
      }
      if (Math.abs(s.x - s.t) < 0.002 && Math.abs(s.v) < 0.02) {
        wrap._goo = null;
        btn.style.transform = ''; btn.style.transition = ''; wrap.style.height = ''; wrap.style.overflow = ''; wrap.style.marginBottom = '';
        if (!show) wrap.style.display = 'none';
        return;
      }
      requestAnimationFrame(frame);
    })(performance.now());
  }
  function refreshCount() {
    var sel = selArtist();
    fetch('/catalog/archived/data?page=0' + (sel ? '&artist=' + encodeURIComponent(sel) : ''), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.success || String(selArtist() || '') !== String(sel || '')) return;
        setCount((d.counts && typeof d.counts.all === 'number') ? d.counts.all : (d.releases || []).length);
      }).catch(function () {});
  }
  function wireSidebar() {
    var btn = document.getElementById('sidebarArchiveBtn');
    if (btn && !btn.dataset.wired) { btn.dataset.wired = '1'; btn.addEventListener('click', function () { open(); }); }
    refreshCount();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wireSidebar); else wireSidebar();
  window.addEventListener('llink:archive-changed', refreshCount);
  window.addEventListener('artistChanged', function () { setTimeout(refreshCount, 0); });

  // The grid's coverless-card gradients and its pick by page id (releases-page.js REL_GRADIENTS / gradientFor: keep the two
  // in step), so an archived page keeps the placeholder it had in the grid. The modal also opens away from the grid page.
  var ARCH_GRADIENTS = [
    'linear-gradient(145deg, #fad0c4 0%, #ffd1ff 50%, #e0c3fc 100%)',
    'linear-gradient(135deg, #ffecd2 0%, #fcb69f 50%, #ee9ca7 100%)',
    'linear-gradient(160deg, #e0c3fc 0%, #c7ceea 50%, #a1c4fd 100%)',
    'linear-gradient(140deg, #d4fc79 0%, #96e6a1 50%, #84fab0 100%)',
    'linear-gradient(135deg, #ffeaa7 0%, #fab1a0 50%, #fd79a8 100%)',
    'linear-gradient(150deg, #a1c4fd 0%, #c2e9fb 50%, #d4fc79 100%)',
    'linear-gradient(145deg, #fbc2eb 0%, #e6dee9 50%, #a6c1ee 100%)',
    'linear-gradient(135deg, #f5f7fa 0%, #e4d9ff 50%, #fad0c4 100%)'
  ];
  function archGradientFor(id) {
    var hash = String(id || '').split('').reduce(function (a, c) { return a + c.charCodeAt(0); }, 0);
    return ARCH_GRADIENTS[hash % ARCH_GRADIENTS.length];
  }

  window.ArchiveModal = { open: open, setCount: setCount, refreshCount: refreshCount, restoreMany: restoreMany, deleteMany: deleteMany, gradientFor: archGradientFor };
})();
